import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-details-contenue-document',
    templateUrl: './details-contenue-document.component.html',
    styleUrls: ['./details-contenue-document.component.scss']
})
export class DetailsContenueDocumentComponent implements OnInit {
    reference: string | null = null;
    selectedTab: string = 'devis'; // Default to 'devis'

    constructor(private router: Router, private route: ActivatedRoute) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.reference = params.get('reference');

            if (!this.reference && this.route.parent) {
                this.reference = this.route.parent.snapshot.paramMap.get('reference');
            }

            if (!this.reference) {
                this.router.navigate(['/bibliotheque-clients/actif']);
                return;
            }

            const validTabs = ['devis', 'commande-client', 'bon-livraison', 'facture', 'bon-sortie'];


            const savedTab = localStorage.getItem('selectedDocumentTab');


            const currentUrl = this.router.url;
            let currentTab = 'devis';
            if (currentUrl.includes('/devis')) {
                currentTab = 'devis';
            } else if (currentUrl.includes('/commande-client')) {
                currentTab = 'commande-client';
            } else if (currentUrl.includes('/bon-livraison')) {
                currentTab = 'bon-livraison';
            } else if (currentUrl.includes('/facture')) {
                currentTab = 'facture';
            } else if (currentUrl.includes('/bon-sortie')) {
                currentTab = 'bon-sortie';
            }


            this.selectedTab = savedTab && validTabs.includes(savedTab) ? savedTab : currentTab;

            if (this.reference && currentUrl === `/tiers/clients/details/${this.reference}/detail-contenue-document`) {
                this.router.navigate([`/tiers/clients/details/${this.reference}/detail-contenue-document/${this.selectedTab}`], {
                    replaceUrl: true
                });
            }
        });
    }

    selectTab(tab: string): void {
        this.selectedTab = tab;
        localStorage.setItem('selectedDocumentTab', tab);
        if (this.reference) {
            this.router.navigate([`/tiers/clients/details/${this.reference}/detail-contenue-document/${tab}`], {
                replaceUrl: true
            });
            console.log('Navigated to tab:', tab);
        } else {
            console.error('Cannot navigate: reference is null');
            this.router.navigate(['/bibliotheque-clients/actif']);
        }
    }
}
